import { MoreOutlined } from "@ant-design/icons";
import {
  DatePicker,
  Dropdown,
  Empty,
  Menu,
  Space,
  Grid,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentDistributor,
  setCurrentStaff,
} from "../../redux/actions/user.actions";
import { setLoading } from "../../redux/actions/app.actions";
import { ReactComponent as ChevronLeft } from "assets/icons/chevronLeftIco.svg";
import { ReactComponent as ChevronRight } from "assets/icons/chevronRightIco.svg";

import {
  addNewStaff,
  getAllStaff,
  updateStaff,
} from "../../services/staffs.services";
import moment from "moment-timezone";
import { getAllOrders } from "services/order.services";

import {
  CarOutlined,
  CloseCircleOutlined,
  CloudOutlined,
  ExclamationCircleOutlined,
  ShopOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

import "./Appointment.scss";
import EventDrawer from "components/EventDrawer/EventDrawer";
import { setCurrentBooking } from "redux/actions/booking.actions";

import { findWindows } from "windows-iana";
import {
  addonsTextReducer,
  convertMinsToHrsMins,
  getBackgroundColorAndTooltip,
} from "utils/common";
import { uniqBy } from "lodash";

import queryString from "query-string";
import { useLocation } from "react-router";
import { replace } from "connected-react-router";

const { useBreakpoint } = Grid;

const OrderStatus = {
  Pending: 1,
  Cancel: 2,
  Completed: 3,
  "No Show": 4,
  Arrived: 5,
};

window.appointmentsSchedulerAbort = undefined


const Menue = (record, dispatch, setModalVisible) => (
  <Menu style={{ borderRadius: 6, border: "2px solid #CDD5D8 " }}>
    <Menu.Item
      onClick={() => {
        dispatch(setCurrentStaff(record));

        setModalVisible(true);
        // console.log(record)
      }}
    >
      s Edit
    </Menu.Item>
  </Menu>
);
let bgColor = "";
let tooltip = "";

const Appointments = ({ date: propsDate }) => {
  const intervalRef = useRef();
  const screens = useBreakpoint();
  const isSmallDevice = !screens.md;

  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(moment());
  const [modalVisible, setModalVisible] = useState(false);

  const [showAppointmentDrawer, setAppointmentDrawer] = useState(false);
  const [showGuestDrawer, setshowGuestDrawer] = useState(false);

  const allStaffs = useSelector((state) => state.user.allStaff);
  const allOrders = useSelector((state) => state.orders.allOrders);
  const currentStaff = useSelector((state) => state.user.currentUser);
  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const location = useLocation();

  useEffect(() => {
    if (currentStaff?.staffId) {
      window.appointmentsSchedulerAbort = new AbortController();

      getData(true, window?.appointmentsSchedulerAbort?.signal);
      intervalRef.current = setInterval(() => {
        if (window.appointmentsSchedulerAbort) {
          window.appointmentsSchedulerAbort.abort();
        }
        window.appointmentsSchedulerAbort = new AbortController();
        getData(false, window?.appointmentsSchedulerAbort?.signal);
      }, 60000); // 60 seconds
    }

    return () => {
      if (intervalRef?.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [date, currentStaff]);

  // useEffect(() => {
  //   if (currentStaff?.staffId)
  //     dispatch(
  //       getAllStaff(null, ["Nurse", "Nurse Lead", "Nurse Practitioner"])
  //     );
  // }, [currentStaff?.staffId]);

  const getOrderStatus = (statusId, order) => {
    for (const key in OrderStatus) {
      if (statusId === OrderStatus[key]) {
        return key;
      }
    }
  };
  const getData = async (showLoading = true, signal) => {
    const windowsTimezone = findWindows(moment.tz.guess());
    if (showLoading) dispatch(setLoading(true));
    await dispatch(
      getAllOrders(
        {
          // facilityId: currentStaff?.facilityId,
          filterType: 1,
          requestedDate: moment.utc(date).local().format("YYYY-MM-DD"),
          staffAssigned: true,
          nurseId: currentStaff?.roleName === "Admin" ? undefined : currentStaff?.staffId,
          timezone: windowsTimezone?.[0],
          facilityIds: [],
        },
        showLoading,
        signal
      )
    );
    if (showLoading) dispatch(setLoading(false));
  };

  const getFormatedDate = (order) => {
    const { serviceDate, timezone } = order;

    const orderMoment = moment(serviceDate);
    const str = orderMoment.fromNow();

    if (str && str.includes("ago")) {
      return `Past ${str}`;
    } else {
      return `Due ${str}`;
    }
  };


  const onNavigate = async (value) => {
    if (value === "add") {
      const newDate = moment(date).add(1, "day");
      updateDate(newDate);
    } else {
      const newDate = moment(date).subtract(1, "day");
      updateDate(newDate);
    }
  };

  const updateDate = async (date) => {
    const momentDateFormatted = moment(date).format("DD-yy-MM")
    const qs = queryString.parse(location.search, {
      arrayFormat: "bracket",
      ignoreQueryPrefix: true
    })
    qs.date = momentDateFormatted
    dispatch(replace({
      search: queryString.stringify(qs, {
        arrayFormat: "bracket",
        ignoreQueryPrefix: true
      })
    }))


    setDate(date)
  }

  const renderAppointments = () => {
    if (allOrders.length) {
      return uniqBy(allOrders, "orderId")
        .filter((appointment) => {
          return (
            moment(appointment.serviceDate).format("YYYY-MM-DD") ===
            moment(date).format("YYYY-MM-DD") &&
            currentStaff?.facilityIds?.includes(appointment?.facilityId)
          );
        })
        .map((order) => {
          const [bgColor, tooltip] = getBackgroundColorAndTooltip(order);

          return (
            <div
              onClick={() => {
                // dispatch(setCurrentOrder(order)); // is it needed?
                dispatch(setCurrentBooking(order));
                setModalVisible(true);
              }}
              style={{
                width: "100%",
                minHeight: 149,
                borderRadius: 4,
                boxShadow: "0px 10px 10px rgba(22, 31, 58, 0.08)",
                background: "#fff",
                margin: "12px 0px",
                padding: 16,
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="flex gap-12">
                  <p
                    style={{
                      margin: 0,
                      fontSize: 16,
                      fontFamily: "tradeGothic",
                    }}
                  >
                    Booking ID: {order.orderId}
                  </p>
                  <Space align="center">
                    {/* source 1 for adming, 2 for guest */}
                    {order?.source === 2 && (
                      <Tooltip title="Guest Booking">
                        <CloudOutlined
                          style={{
                            color: "#000",
                            display: "inline-flex",
                            fontSize: 18,
                          }}
                        />
                      </Tooltip>
                    )}
                    {order?.operationTypeId === 1 && (
                      <Tooltip title="Mobile Booking">
                        <CarOutlined
                          style={{
                            color: "#000",
                            display: "inline-flex",
                            fontSize: 18,
                          }}
                        />
                      </Tooltip>
                    )}
                    {order?.operationTypeId === 2 && (
                      <Tooltip title="Clinic Booking">
                        <ShopOutlined
                          style={{
                            color: "#000",
                            display: "inline-flex",
                            fontSize: 17,
                          }}
                        />
                      </Tooltip>
                    )}
                    {order?.operationTypeId === 3 && (
                      <Tooltip title="Telehealth Booking">
                        <VideoCameraOutlined
                          style={{
                            color: "#000",
                            fontSize: 17,
                          }}
                        />
                      </Tooltip>
                    )}
                    {order?.orderStatus === 2 && (
                      <Tooltip title="Cancelled">
                        <CloseCircleOutlined
                          style={{
                            color: "#000",
                            fontSize: 17,
                          }}
                        />
                      </Tooltip>
                    )}
                    {order?.hasContraindication && (
                      <Tooltip title="Has Contraindication">
                        <ExclamationCircleOutlined
                          style={{
                            color: "#000",
                            fontSize: 17,
                          }}
                        />
                      </Tooltip>

                    )}
                  </Space>
                </div>
                <p
                  style={{ margin: 0, fontSize: 16, fontFamily: "tradeGothic" }}
                >
                  {getFormatedDate(order)}
                </p>
              </div>
              <p
                style={{
                  color: "#486BAF",
                  fontSize: 16,
                  fontFamily: "tradeGothic",
                  margin: 0,
                }}
              >
                {moment(order?.serviceDate).format("h:mm a")}
              </p>
              <Tooltip
                title={
                  order?.isCustomerProfileFlagged ? "Profile is flagged" : ""
                }
                placement="topLeft"
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      fontFamily: "tradeGothic",
                      margin: 0,
                      color: order?.isCustomerProfileFlagged
                        ? "#ff4d4f"
                        : "#323232",
                    }}
                  >
                    {order.customerFullName}
                  </p>
                </div>
              </Tooltip>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p
                  style={{ margin: 0, fontSize: 16, fontFamily: "tradeGothic" }}
                >
                  {order?.formattedServicesWithBoostsStringWithDuration}
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: 16,
                    fontWeight: "bold",
                    fontFamily: "tradeGothic",
                  }}
                >
                  Status:{" "}
                  <span className={`${bgColor}`}>
                    {getOrderStatus(order?.orderStatus) === "Cancel"
                      ? "Cancelled"
                      : getOrderStatus(order?.orderStatus)}
                    {/* TODO: get baackend team to update */}
                  </span>
                </p>
              </div>
            </div>
          );
        });
    } else {
      return (
        <div style={{ height: 300, display: "flex", alignItems: "center" }}>
          <Empty description="No Appointments" />
        </div>
      );
    }
  };

  return (
    <div>
      <EventDrawer
        order={currentOrder}
        setShowEventDrawer={setModalVisible}
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
          dispatch(setCurrentStaff(null));
        }}
        getData={getData}
      />
      <div
        style={{
          height: screens.md ? 80 : "auto",
          background: "#e5e8ee",
          display: "flex",
          flexDirection: screens.md ? "row" : "column",
          justifyContent: "space-between",
          alignItems: screens.md ? "center" : "flex-start",
        }}
      >
        <h2
          style={{
            color: "#15213B",
            fontFamily: "tradeGothicBold",
            margin: 0,
            marginBottom: screens.md ? 0 : 12,
          }}
        >{`Appointments (${allOrders?.length})`}</h2>
        <div className="dayWeekSelectorContainer">
          <button
            className="arrows"
            onClick={() => {
              onNavigate("less");
            }}
          >
            <ChevronLeft />
          </button>
          <div style={{ position: "relative" }}>
            <DatePicker
              dropdownClassName="dayWeekSelectorDropdown"
              defaultValue={date}
              value={date}
              placement="bottomLeft"
              bordered={false}
              open={open}
              className="hiddenDatePicker"
              style={{ visibility: "hidden", width: 0 }}
              onOpenChange={(open) => setOpen(open)}
              dropdownAlign={{
                offset: [-68, 14],
              }}
              onChange={async (date) => {
                updateDate(date);
              }}
            />
            <button className="dateButton" onClick={() => setOpen(!open)}>
              {date.format("DD MMM YYYY")}
            </button>
          </div>
          <button
            className="arrows"
            onClick={() => {
              onNavigate("add");
            }}
          >
            <ChevronRight />
          </button>
        </div>
        {screens.md && <div style={{ width: 230 }}>&nbsp;</div>}
      </div>
      <div
        style={{
          height: isSmallDevice
            ? "calc(100vh - 135px - 16px - 30px)"
            : "calc(100vh - 80px - 16px - 80px)",
          height: isSmallDevice
            ? "calc(100dvh - 135px - 16px - 30px)"
            : "calc(100dvh - 80px - 16px - 80px)",
          background: "#e5e8ee",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: 30,
          overflow: "auto",
        }}
      >
        {renderAppointments()}
      </div>
    </div>
  );
};

export default Appointments;
